"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuthSaga = void 0;

var framework_1 = require("@xbox/framework");

var social_core_1 = require("@xbox/social-core");

var inversify_1 = require("inversify");

var redux_saga_1 = require("redux-saga");

var effects_1 = require("redux-saga/effects");

var AuthActions_1 = require("../actions/AuthActions");

var ExperimentsActions_1 = require("../actions/ExperimentsActions");

var AuthReducer_1 = require("../reducers/AuthReducer");

var PrivacyActions_1 = require("../actions/PrivacyActions");

var ActivityFeedActions_1 = require("../actions/ActivityFeedActions");

var authRedirectRequiredChannel = redux_saga_1.channel();

var AuthSaga =
/** @class */
function () {
  function AuthSaga(authProvider, userManager, telemetryService, appConfig, authComponents, httpRequestService) {
    this.authProvider = authProvider;
    this.userManager = userManager;
    this.telemetryService = telemetryService;
    this.appConfig = appConfig;
    this.authComponents = authComponents;
    this.httpRequestService = httpRequestService;
    this.sagas = [this.watchCheckIfSignedIn(), this.watchAuthenticate(), this.watchAuthRedirectRequired(), this.watchAuthRedirectCompletedWeb(), this.watchSiSuRedirectCompletedWeb(), this.watchSignOut()];
  }

  AuthSaga.prototype._checkIfSignedIn = function (cookies) {
    var user, error_1;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 8,, 11]); // It's safe to call initialize auth repeatedly


          return [4
          /*yield*/
          , this._initializeAuth()];

        case 1:
          // It's safe to call initialize auth repeatedly
          _a.sent();

          return [4
          /*yield*/
          , this.userManager.signInSilently(cookies.payload)];

        case 2:
          user = _a.sent();
          return [4
          /*yield*/
          , effects_1.put(AuthActions_1.AuthActions.authCompleted())];

        case 3:
          _a.sent();

          this.telemetryService.setAuthenticatedUserContext(user.xuid);
          return [4
          /*yield*/
          , effects_1.put(AuthActions_1.AuthActions.updateCurrentUser(user))];

        case 4:
          _a.sent();

          return [4
          /*yield*/
          , effects_1.put(AuthActions_1.AuthActions.authConnectionStateChanged(AuthReducer_1.AuthConnectionState.loggedIn))];

        case 5:
          _a.sent();

          return [4
          /*yield*/
          , effects_1.put(PrivacyActions_1.PrivacyActions.getPrivacySettings(user.xuid))];

        case 6:
          _a.sent();

          return [4
          /*yield*/
          , effects_1.put(ActivityFeedActions_1.ActivityFeedActions.getFeedSettings(user.xuid))];

        case 7:
          _a.sent();

          return [3
          /*break*/
          , 11];

        case 8:
          error_1 = _a.sent();
          return [4
          /*yield*/
          , effects_1.put(AuthActions_1.AuthActions.updateCurrentUser(undefined))];

        case 9:
          _a.sent();

          return [4
          /*yield*/
          , effects_1.put(AuthActions_1.AuthActions.authConnectionStateChanged(AuthReducer_1.AuthConnectionState.loggedOut))];

        case 10:
          _a.sent();

          return [3
          /*break*/
          , 11];

        case 11:
          return [4
          /*yield*/
          , effects_1.put(ExperimentsActions_1.ExperimentsActions.fetchExperiments())];

        case 12:
          _a.sent();

          return [2
          /*return*/
          ];
      }
    });
  };

  AuthSaga.prototype._authRedirectRequired = function (params) {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          console.log("AuthSaga: AuthRedirectRequired dispatched.");
          return [4
          /*yield*/
          , effects_1.put(AuthActions_1.AuthActions.authRedirectRequired(params))];

        case 1:
          _a.sent();

          return [2
          /*return*/
          ];
      }
    });
  };

  AuthSaga.prototype._authenticate = function (cookies) {
    var user, error_2;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 8,, 12]);

          return [4
          /*yield*/
          , this._initializeAuth()];

        case 1:
          _a.sent();

          return [4
          /*yield*/
          , this.userManager.signIn(cookies.payload)];

        case 2:
          user = _a.sent();
          return [4
          /*yield*/
          , effects_1.put(AuthActions_1.AuthActions.authCompleted())];

        case 3:
          _a.sent();

          this.telemetryService.setAuthenticatedUserContext(user.xuid);
          return [4
          /*yield*/
          , effects_1.put(AuthActions_1.AuthActions.updateCurrentUser(user))];

        case 4:
          _a.sent();

          return [4
          /*yield*/
          , effects_1.put(AuthActions_1.AuthActions.authConnectionStateChanged(AuthReducer_1.AuthConnectionState.loggedIn))];

        case 5:
          _a.sent();

          return [4
          /*yield*/
          , effects_1.put(PrivacyActions_1.PrivacyActions.getPrivacySettings(user.xuid))];

        case 6:
          _a.sent();

          return [4
          /*yield*/
          , effects_1.put(ActivityFeedActions_1.ActivityFeedActions.getFeedSettings(user.xuid))];

        case 7:
          _a.sent();

          return [3
          /*break*/
          , 12];

        case 8:
          error_2 = _a.sent();
          console.error(error_2);
          return [4
          /*yield*/
          , effects_1.put(AuthActions_1.AuthActions.authFailed(error_2))];

        case 9:
          _a.sent();

          return [4
          /*yield*/
          , effects_1.put(AuthActions_1.AuthActions.updateCurrentUser(undefined))];

        case 10:
          _a.sent();

          return [4
          /*yield*/
          , effects_1.put(AuthActions_1.AuthActions.authConnectionStateChanged(AuthReducer_1.AuthConnectionState.loggedOut))];

        case 11:
          _a.sent();

          return [3
          /*break*/
          , 12];

        case 12:
          return [2
          /*return*/
          ];
      }
    });
  };

  AuthSaga.prototype._authRedirectCompletedWeb = function (action) {
    var user, error_3;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 9,, 13]);

          return [4
          /*yield*/
          , this._initializeAuth()];

        case 1:
          _a.sent();

          return [4
          /*yield*/
          , this.authProvider.resumeMsaForWeb(action.payload.url)];

        case 2:
          _a.sent();

          return [4
          /*yield*/
          , this.userManager.signInSilently(action.payload.cookies)];

        case 3:
          user = _a.sent();
          return [4
          /*yield*/
          , effects_1.put(AuthActions_1.AuthActions.authCompleted())];

        case 4:
          _a.sent();

          this.telemetryService.setAuthenticatedUserContext(user.xuid);
          return [4
          /*yield*/
          , effects_1.put(AuthActions_1.AuthActions.updateCurrentUser(user))];

        case 5:
          _a.sent();

          return [4
          /*yield*/
          , effects_1.put(AuthActions_1.AuthActions.authConnectionStateChanged(AuthReducer_1.AuthConnectionState.loggedIn))];

        case 6:
          _a.sent();

          return [4
          /*yield*/
          , effects_1.put(PrivacyActions_1.PrivacyActions.getPrivacySettings(user.xuid))];

        case 7:
          _a.sent();

          return [4
          /*yield*/
          , effects_1.put(ActivityFeedActions_1.ActivityFeedActions.getFeedSettings(user.xuid))];

        case 8:
          _a.sent();

          return [3
          /*break*/
          , 13];

        case 9:
          error_3 = _a.sent();
          return [4
          /*yield*/
          , effects_1.put(AuthActions_1.AuthActions.authFailed(error_3))];

        case 10:
          _a.sent();

          return [4
          /*yield*/
          , effects_1.put(AuthActions_1.AuthActions.updateCurrentUser(undefined))];

        case 11:
          _a.sent();

          return [4
          /*yield*/
          , effects_1.put(AuthActions_1.AuthActions.authConnectionStateChanged(AuthReducer_1.AuthConnectionState.loggedOut))];

        case 12:
          _a.sent();

          return [3
          /*break*/
          , 13];

        case 13:
          return [2
          /*return*/
          ];
      }
    });
  };

  AuthSaga.prototype._siSuRedirectCompletedWeb = function (action) {
    var user, error_4;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 9,, 13]);

          return [4
          /*yield*/
          , this._initializeAuth()];

        case 1:
          _a.sent();

          return [4
          /*yield*/
          , this.authProvider.resumeSisuForWeb(action.payload.url)];

        case 2:
          _a.sent();

          return [4
          /*yield*/
          , this.userManager.signInSilently(action.payload.cookies)];

        case 3:
          user = _a.sent();
          return [4
          /*yield*/
          , effects_1.put(AuthActions_1.AuthActions.authCompleted())];

        case 4:
          _a.sent();

          this.telemetryService.setAuthenticatedUserContext(user.xuid);
          return [4
          /*yield*/
          , effects_1.put(AuthActions_1.AuthActions.updateCurrentUser(user))];

        case 5:
          _a.sent();

          return [4
          /*yield*/
          , effects_1.put(AuthActions_1.AuthActions.authConnectionStateChanged(AuthReducer_1.AuthConnectionState.loggedIn))];

        case 6:
          _a.sent();

          return [4
          /*yield*/
          , effects_1.put(PrivacyActions_1.PrivacyActions.getPrivacySettings(user.xuid))];

        case 7:
          _a.sent();

          return [4
          /*yield*/
          , effects_1.put(ActivityFeedActions_1.ActivityFeedActions.getFeedSettings(user.xuid))];

        case 8:
          _a.sent();

          return [3
          /*break*/
          , 13];

        case 9:
          error_4 = _a.sent();
          return [4
          /*yield*/
          , effects_1.put(AuthActions_1.AuthActions.authFailed(error_4))];

        case 10:
          _a.sent();

          return [4
          /*yield*/
          , effects_1.put(AuthActions_1.AuthActions.updateCurrentUser(undefined))];

        case 11:
          _a.sent();

          return [4
          /*yield*/
          , effects_1.put(AuthActions_1.AuthActions.authConnectionStateChanged(AuthReducer_1.AuthConnectionState.loggedOut))];

        case 12:
          _a.sent();

          return [3
          /*break*/
          , 13];

        case 13:
          return [2
          /*return*/
          ];
      }
    });
  };

  AuthSaga.prototype._signOut = function (cookies) {
    var error_5;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 5,, 7]);

          return [4
          /*yield*/
          , this.userManager.signOut(cookies.payload)];

        case 1:
          _a.sent();

          return [4
          /*yield*/
          , effects_1.put(AuthActions_1.AuthActions.signOutCompleted())];

        case 2:
          _a.sent();

          return [4
          /*yield*/
          , effects_1.put(AuthActions_1.AuthActions.updateCurrentUser(undefined))];

        case 3:
          _a.sent();

          return [4
          /*yield*/
          , effects_1.put(AuthActions_1.AuthActions.authConnectionStateChanged(AuthReducer_1.AuthConnectionState.loggedOut))];

        case 4:
          _a.sent();

          return [3
          /*break*/
          , 7];

        case 5:
          error_5 = _a.sent();
          return [4
          /*yield*/
          , effects_1.put(AuthActions_1.AuthActions.signOutFailed(error_5))];

        case 6:
          _a.sent();

          return [3
          /*break*/
          , 7];

        case 7:
          return [2
          /*return*/
          ];
      }
    });
  };

  AuthSaga.prototype._initializeAuth = function () {
    var initArgs;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          initArgs = {
            clientId: this.appConfig.clientId,
            isFirstParty: this.appConfig.isFirstParty,
            sandbox: this.appConfig.sandbox,
            titleId: this.appConfig.titleId,
            msaRedirectUri: this.appConfig.msaRedirectUri,
            sisuRedirectUri: this.appConfig.siSuRedirectUri
          };
          return [4
          /*yield*/
          , this.authProvider.init(initArgs, this.authComponents, this.httpRequestService, {
            showUrl: function showUrl(startUri, endUri, suppressUi) {
              var promiseCompletionSource = new framework_1.PromiseCompletionSource();
              console.log("AuthSaga: ShowUrl requested. startUri: " + startUri + ", endUri: " + endUri + ", suppressUi: " + suppressUi);
              authRedirectRequiredChannel.put({
                startUri: startUri,
                endUri: endUri,
                suppressUi: suppressUi,
                promiseCompletionSource: promiseCompletionSource
              });
              return promiseCompletionSource.promise;
            }
          })];

        case 1:
          _a.sent();

          return [2
          /*return*/
          ];
      }
    });
  };

  AuthSaga.prototype.watchCheckIfSignedIn = function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , effects_1.takeEvery(AuthActions_1.AuthActions.checkIfSignedIn.type, this._checkIfSignedIn.bind(this))];

        case 1:
          _a.sent();

          return [2
          /*return*/
          ];
      }
    });
  };

  AuthSaga.prototype.watchAuthRedirectRequired = function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , effects_1.takeEvery(authRedirectRequiredChannel, this._authRedirectRequired.bind(this))];

        case 1:
          _a.sent();

          return [2
          /*return*/
          ];
      }
    });
  };

  AuthSaga.prototype.watchAuthenticate = function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , effects_1.takeEvery(AuthActions_1.AuthActions.authenticate.type, this._authenticate.bind(this))];

        case 1:
          _a.sent();

          return [2
          /*return*/
          ];
      }
    });
  };

  AuthSaga.prototype.watchAuthRedirectCompletedWeb = function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , effects_1.takeEvery(AuthActions_1.AuthActions.authRedirectCompletedWeb.type, this._authRedirectCompletedWeb.bind(this))];

        case 1:
          _a.sent();

          return [2
          /*return*/
          ];
      }
    });
  };

  AuthSaga.prototype.watchSiSuRedirectCompletedWeb = function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , effects_1.takeEvery(AuthActions_1.AuthActions.siSuRedirectCompletedWeb.type, this._siSuRedirectCompletedWeb.bind(this))];

        case 1:
          _a.sent();

          return [2
          /*return*/
          ];
      }
    });
  };

  AuthSaga.prototype.watchSignOut = function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , effects_1.takeEvery(AuthActions_1.AuthActions.signOut.type, this._signOut.bind(this))];

        case 1:
          _a.sent();

          return [2
          /*return*/
          ];
      }
    });
  };

  AuthSaga = __decorate([inversify_1.injectable(), __param(0, inversify_1.inject(social_core_1.XSocialSymbols.IXalAuthProvider)), __param(1, inversify_1.inject(social_core_1.XSocialSymbols.IUserManager)), __param(2, inversify_1.inject(social_core_1.XSocialSymbols.ITelemetryService)), __param(3, inversify_1.inject(social_core_1.XSocialSymbols.IAppConfig)), __param(4, inversify_1.inject(social_core_1.XSocialSymbols.IAuthComponents)), __param(5, inversify_1.inject(social_core_1.XSocialSymbols.IHttpRequestService)), __metadata("design:paramtypes", [Object, Object, Object, Object, Object, Object])], AuthSaga);
  return AuthSaga;
}();

exports.AuthSaga = AuthSaga;